<div
    #banner
    class="connectivity-banner"
    [class.is-visible]="!!snapshot.banner"
    [class.is-offline]="kind === 'offline'"
    [class.is-server]="kind === 'server'"
    [class.is-restored]="kind === 'restored'"
    [attr.aria-hidden]="snapshot.banner ? null : 'true'">
    <div class="connectivity-banner__inner">
        <svg
            *ngIf="kind === 'offline'"
            class="connectivity-banner__icon"
            viewBox="0 0 24 24"
            fill="none"
            aria-hidden="true">
            <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
                d="M3 3l8.735 8.735m0 0a.374.374 0 1 1 .53.53m-.53-.53.53.53m0 0L21 21M14.652 9.348a3.75 3.75 0 0 1 0 5.304m2.121-7.425a6.75 6.75 0 0 1 0 9.546m2.121-11.667a9.75 9.75 0 0 1 0 13.788m-9.546-4.242a3.733 3.733 0 0 1-1.06-2.122m-1.061 4.243a6.75 6.75 0 0 1-1.625-6.929m-.496 9.05c-3.068-3.067-3.664-7.67-1.79-11.334M12 12h.008v.008H12V12Z"/>
        </svg>
        <svg
            *ngIf="kind === 'server'"
            class="connectivity-banner__icon"
            viewBox="0 0 24 24"
            fill="none"
            aria-hidden="true">
            <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
                d="M21.75 17.25v-.228a4.5 4.5 0 0 0-.12-1.03l-2.268-9.64a3.375 3.375 0 0 0-3.285-2.602H7.923a3.375 3.375 0 0 0-3.285 2.602l-2.268 9.64a4.5 4.5 0 0 0-.12 1.03v.228m19.5 0a3 3 0 0 1-3 3H5.25a3 3 0 0 1-3-3m19.5 0a3 3 0 0 0-3-3H5.25a3 3 0 0 0-3 3m16.5 0h.008v.008h-.008v-.008Zm-3 0h.008v.008h-.008v-.008Z"/>
        </svg>
        <svg
            *ngIf="kind === 'restored'"
            class="connectivity-banner__icon"
            viewBox="0 0 24 24"
            fill="none"
            aria-hidden="true">
            <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
                d="M8.288 15.038a5.25 5.25 0 0 1 7.424 0M5.106 11.856c3.807-3.808 9.98-3.808 13.788 0M1.924 8.674c5.565-5.565 14.587-5.565 20.152 0M12.53 18.22l-.53.53-.53-.53a.75.75 0 0 1 1.06 0Z"/>
        </svg>

        <p class="connectivity-banner__message" role="status" aria-live="polite" aria-atomic="true">
            {{ label }}
        </p>

        <button
            *ngIf="kind === 'offline' || kind === 'server'"
            type="button"
            class="connectivity-banner__retry"
            (click)="retry()"
            [disabled]="snapshot.checking"
            [attr.aria-busy]="snapshot.checking ? 'true' : null"
            aria-label="Check connection again">
            {{ snapshot.checking ? 'Checking…' : 'Retry' }}
        </button>
    </div>
</div>
